<div class="about-el-container" [style]="background">
  <div class="about-el">
    <div class="about-el-about">
      <app-texts [texts]="[
        {text: ['about us', 'about us']}
      ]"/>
    </div>
    <div class="about-el-label">
      <app-texts [texts]="label"/>
    </div>
    <div class="about-el-text">
      <app-texts [texts]="[
        {text: [subtitleRus, subtitleEn]}
      ]"/>
    </div>
  </div>
</div>
